module.exports = __webpack_public_path__ + "img/parallel-dimension.9367165d.jpg";